import { PC_CONNECTION_STATE as SPCS } from "../server-contracts/pcConnectionStates.js";
/**
 * RtcConnectionState
 * ------------------
 *
 * Client-side RTCPeerConnection state vocabulary.
 *
 * IMPORTANT:
 * This mirrors the signaling server contract vocabulary for
 * PC_CONNECTION_STATE reporting.
 */
export const RTC_CONNECTION_STATE = {
    NEW: SPCS.NEW,
    CONNECTING: SPCS.CONNECTING,
    CONNECTED: SPCS.CONNECTED,
    DISCONNECTED: SPCS.DISCONNECTED,
    FAILED: SPCS.FAILED,
    CLOSED: SPCS.CLOSED,
};
/**
 * IceGatheringState
 * -----------------
 *
 * Local normalized view of ICE gathering progress.
 *
 * IDLE:
 *   Peer connection not created or ICE gathering not started.
 *
 * GATHERING:
 *   ICE gathering in progress.
 *
 * COMPLETE:
 *   ICE gathering completed.
 */
export const ICE_GATHERING_STATE = {
    IDLE: "IDLE",
    GATHERING: "GATHERING",
    COMPLETE: "COMPLETE",
};
/**
 * makeInitialSessionDescriptionState
 * ----------------------------------
 */
export function makeInitialSessionDescriptionState() {
    return {
        hasLocalDescription: false,
        hasRemoteDescription: false,
    };
}
/**
 * makeInitialRemoteMediaState
 * ---------------------------
 */
export function makeInitialRemoteMediaState() {
    return {
        hasRemoteStream: false,
        hasRemoteAudioTrack: false,
        hasRemoteVideoTrack: false,
    };
}
/**
 * makeInitialLocalRtcState
 * ------------------------
 */
export function makeInitialLocalRtcState() {
    return {
        connectionState: RTC_CONNECTION_STATE.NEW,
        iceGatheringState: ICE_GATHERING_STATE.IDLE,
        descriptions: makeInitialSessionDescriptionState(),
        remoteMedia: makeInitialRemoteMediaState(),
        isMakingOffer: false,
        isSettingRemoteAnswerPending: false,
        isNegotiationNeeded: false,
        error: null,
    };
}
